



























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
	Gateway,
	GatewaysApi,
	Node,
	NodesApi,
	Product,
	Sensor,
	SensorsApi,
	ThingGroupsApi,
	Transceiver,
	TransceiversApi,
} from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import InlineEditor from '@/components/display/inline-editor.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';
import ConfirmModal from '@/components/display/confirm-modal.vue';

@Component({
	components: { ConfirmModal, InlineEditor, InformationRow },
})
export default class StatusRow extends Vue {
	@Prop({ required: true })
	private entity!: Transceiver | Sensor | Gateway | Node;

	@Prop({ required: true })
	private entityType!: 'transceiver' | 'sensor' | 'gateway' | 'node';

	private submitting = false;

	private readonly transceiversApi = new TransceiversApi();
	private readonly sensorsApi = new SensorsApi();
	private readonly gatewaysApi = new GatewaysApi();
	private readonly nodesApi = new NodesApi();
	private readonly toast = new Toast();
	private readonly modalId: string = `updateLocationModal${Math.random()}`;

	private async decommission() {
		this.submitting = true;
		try {
			switch (this.entityType) {
				case 'transceiver':
					await this.transceiversApi.decommissionTransceiver(this.entity.id!);
					break;
				case 'sensor':
					await this.sensorsApi.decommissionSensor(this.entity.id!);
					break;
				case 'gateway':
					await this.gatewaysApi.decommissionGateway(this.entity.id!);
					break;
				case 'node':
					await this.nodesApi.decommissionNode(this.entity.id!);
					break;
			}
			this.toast.makeToast(`Decommissioned ${this.entityType}`, `Success`, 'success');
			this.entity.status = 'decommissioned';
			this.$bvModal.hide(this.modalId);
		} catch (ex) {
			const { errorMessage } = ApiUtils.handleApiError(
				ex,
				`Error decommissioning ${this.entityType}`,
			);
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}
		this.submitting = false;
	}
}
